export default __webpack_public_path__ + "static/media/customer3.f0b42c40.png";